module.exports = __webpack_public_path__ + "static/media/Huis-4-3.4b72a510.jpg";